import React, { FC, RefObject } from 'react';
import Styles from './CompactMobileSearch.module.scss';

export interface CompactMobileSearchProps {
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  placeholder: string;
  searchIcon: string;
  inputClassName?: string;
  wrapClassName?: string;
  shellClassName?: string;
  iconButtonClassName?: string;
  iconImgClassName?: string;
  showCompactSearch: boolean;
  isSearchExpanded: boolean;
  searchInputRef: RefObject<HTMLInputElement>;
  onOpenMobileSearch: () => void;
  openSearchAriaLabel: string;
  focusSearchAriaLabel?: string;
}

const CompactMobileSearch: FC<CompactMobileSearchProps> = ({
  value,
  onChange,
  onBlur,
  placeholder,
  searchIcon,
  inputClassName = '',
  wrapClassName = '',
  shellClassName = '',
  iconButtonClassName = '',
  iconImgClassName = '',
  showCompactSearch,
  isSearchExpanded,
  searchInputRef,
  onOpenMobileSearch,
  openSearchAriaLabel,
  focusSearchAriaLabel = 'Focus search',
}) => {
  const stickyClassName = [
    Styles.compactSearchStickyWrap,
    wrapClassName,
    showCompactSearch && Styles.compactSearchStickyWrapCompact,
  ]
    .filter(Boolean)
    .join(' ');

  const shellClassNames = [
    Styles.compactSearchShell,
    shellClassName,
    showCompactSearch && Styles.compactSearchShellCompact,
    isSearchExpanded && Styles.compactSearchShellExpanded,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={stickyClassName}>
      <div className={shellClassNames}>
        <input
          ref={searchInputRef}
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          onBlur={onBlur}
          className={`form-control ${Styles.compactSearchField} ${inputClassName}`.trim()}
          tabIndex={showCompactSearch ? -1 : 0}
          aria-hidden={showCompactSearch}
        />
        <button
          type="button"
          className={`${Styles.compactSearchIconButton} ${iconButtonClassName}`.trim()}
          aria-label={showCompactSearch ? openSearchAriaLabel : focusSearchAriaLabel}
          aria-expanded={!showCompactSearch}
          onClick={() => {
            if (showCompactSearch) {
              onOpenMobileSearch();
            } else {
              searchInputRef.current?.focus();
            }
          }}
        >
          <img src={searchIcon} alt="" className={`${Styles.compactSearchIconImg} ${iconImgClassName}`.trim()} />
        </button>
      </div>
    </div>
  );
};

export default CompactMobileSearch;
